export default __webpack_public_path__ + "static/media/R_CMULTIPLANOS.95987137.pdf";